import { z, ZodType } from "zod";

export const PaginatedSchema = <T>(itemSchema: ZodType<T>) =>
  z.object({
    count: z.number().optional(),
    next: z.string().nullable().optional(),
    previous: z.string().nullable().optional(),
    results: z.array(itemSchema).optional(),
  });

export type Paginated<T> = {
  count?: number;
  next?: string | null;
  previous?: string | null;
  results?: T;
};

export type Pagination = { page: number; page_size: number };
